import { render, staticRenderFns } from "./VariableCompensationRanking.vue?vue&type=template&id=b3f63b7c&scoped=true"
import script from "./VariableCompensationRanking.vue?vue&type=script&lang=js"
export * from "./VariableCompensationRanking.vue?vue&type=script&lang=js"
import style0 from "./VariableCompensationRanking.vue?vue&type=style&index=0&id=b3f63b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f63b7c",
  null
  
)

export default component.exports